import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

//components
import Dashboard from './components/dashboard/Dashboard';
import MessagingPage from './components/messagingPage/MessagingPage';
import ProfilePage from './components/profilePage/ProfilePage';
import ReportPage from './components/reportPage/ReportPage';
import SettingsPage from './components/settingsPage/SettingsPage';
import SingIn from './components/auth/signIn/SignIn';
import SingUp from './components/auth/signUp/SignUp';
import ResetPassword from './components/auth/signIn/components/resetPassword/ResetPassword';
import Verification from './components/auth/verification/Verification';
import AllUserProjects from './components/reportPage/components/projects/successProjects/allUserProjects/AllUserProjects';
import CopiedProjects from './components/reportPage/components/projects/successProjects/copiedProjects/CopiedProjects';
import LikedPojects from './components/reportPage/components/projects/successProjects/likedProjects/LikedProjects';
import AllDailyProjects from './components/reportPage/components/projects/dailyProjects/allDailyProjects/AllDailyProjects';
import CopiedDaily from './components/reportPage/components/projects/dailyProjects/copiedDaily/CopiedDaily';
import LikedDaily from './components/reportPage/components/projects/dailyProjects/likedDaily/LikedDaily';
import OrganizationReport from './components/reportPage/components/organization/OrganizationReport';
import BoundPage from './components/boundPage/BoundPage';
import UsersBound from './components/boundPage/components/users/UsersBound';
import OrganizationsBound from './components/boundPage/components/organizations/OrganizationsBound';
import UserDetails from './components/boundPage/components/users/components/userDetails/UserDetails';
import OrgDetails from './components/boundPage/components/organizations/components/orgDetails/OrgDetails';
import DailyStats from './components/boundPage/components/dailyStats/DailyStats';
import ProjectsAllContent from './components/boundPage/components/dailyStats/components/projectsAllContent/ProjectsAllContent';
import ContactsPage from './components/contactsPage/ContactsPage';
import Developers from './components/developers/Developers';

import ImportContactPage from './components/contactsPage/components/importContactPage/ImportContactPage';
import ShowProspected from './components/contactsPage/components/importContactPage/components/showProspected/ShowProspected';
import ContactDetails from './components/contactsPage/components/contactDetails/ContactDetails';
import BestPractices from './components/bestPractices/BestPractices';
import PricingPage from './components/pricing/PricingPage';

function App() {
  return (
    <BrowserRouter>
        <Switch>
          <Route exact path ='/' component={Dashboard} />
          <Route path ='/messaging' component={MessagingPage} />
          <Route path ='/profile' component={ProfilePage} />
          <Route path ='/report' component={ReportPage} />
          <Route path ='/settings' component={SettingsPage} />
          <Route path ='/signIn' component={SingIn} />
          <Route path ='/signUp' component={SingUp} />
          <Route path ='/resetPassword' component={ResetPassword} />
          <Route path ='/verification' component={Verification} />
          <Route path ='/allProjects' component={AllUserProjects} />
          <Route path ='/copiedProjects' component={CopiedProjects} />
          <Route path ='/likedProjects' component={LikedPojects} />
          <Route path ='/allDailyProjects' component={AllDailyProjects} />
          <Route path ='/copiedDaily' component={CopiedDaily} />
          <Route path ='/likedDaily' component={LikedDaily} />
          <Route path ='/orgReport' component={OrganizationReport} />
          <Route path ='/boundStats' component={BoundPage} />
          <Route path ='/usersBound' component={UsersBound} />
          <Route path ='/organizationsBound' component={OrganizationsBound} />
          <Route path ='/user/:id' component={UserDetails} />
          <Route path ='/organization/:id' component={OrgDetails} />
          <Route path ='/dailyStats' component={DailyStats} />
          <Route path ='/projectsAllContent/:id' component={ProjectsAllContent} />
          <Route path ='/contacts' component={ContactsPage} />
          <Route path ='/developers' component={Developers} />
          <Route path ='/importContacts' component={ImportContactPage} />
          <Route path ='/prospects' component={ShowProspected} />
          <Route path ='/contact/:id' component={ContactDetails} />
          <Route path ='/howtouse' component={BestPractices} />
          <Route path ='/pricing' component={PricingPage} />
        </Switch>
      </BrowserRouter>
  );
}

export default App;
